var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.753,
    height: 37.298,
    viewBox: "0 0 33.753 37.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_160",
    x: 0,
    y: 0.008,
    width: 33.743,
    height: 37.291,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_162",
    x: 0.577,
    y: 14.001,
    width: 14.82,
    height: 14.475,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_163",
    x: 19.221,
    y: 0.001,
    width: 14.532,
    height: 14.466,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_164",
    x: 1.002,
    y: 18.263,
    width: 11.036,
    height: 14.474,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_165",
    x: 14.564,
    y: 0,
    width: 11.036,
    height: 14.471,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_166",
    x: 14.954,
    y: 6.883,
    width: 11.024,
    height: 14.482,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_169",
    x: 4.385,
    y: 4.252,
    width: 11.044,
    height: 14.473,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_170",
    x: 18.145,
    y: 18.408,
    width: 11.048,
    height: 14.469,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f99b29",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_104",
    "data-name": "Groupe 104",
    transform: "translate(-1328.69 -823.297)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_160-2",
    "data-name": "Trac\\xE9 160",
    d: "M1348.147,837.328v-3.034h1.994v3.027h5.774v-2.843h-2.5v-2.01h2.5v-2.748h-3.53v-2h5.547v20.451H1347.1v-8.78h-3.078v4.24H1340.8v2.546h3.207v2h-9.761v-1.987h4.51v-4.563h3.229v-7.407h-8.8V823.383h10.825v3.694h2.352v2.01h-2.314v8.241Zm-6.154-11.93h-6.787v6.765h6.787Zm13.932,13.993h-6.782v6.766h6.782Z",
    transform: "translate(-1328.69 -823.38)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_162-2",
    "data-name": "Trac\\xE9 162",
    d: "M1345.445,979.5v1.975h-5.82V979.5Z",
    transform: "translate(-1334.55 -965.5)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_163-2",
    "data-name": "Trac\\xE9 163",
    d: "M1553.163,823.313v1.966h-5.532v-1.966Z",
    transform: "translate(-1523.91 -823.31)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_164-2",
    "data-name": "Trac\\xE9 164",
    d: "M1346.411,1029.035h-2.036v-1.974h2.036Z",
    transform: "translate(-1338.87 -1008.8)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_165-2",
    "data-name": "Trac\\xE9 165",
    d: "M1495.676,823.3h2.036v1.971h-2.036Z",
    transform: "translate(-1476.61 -823.3)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_166-2",
    "data-name": "Trac\\xE9 166",
    d: "M1500.026,900.087h2.024v1.982h-2.024Z",
    transform: "translate(-1480.57 -893.2)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_169-2",
    "data-name": "Trac\\xE9 169",
    d: "M1382.114,870.735h2.044v1.974h-2.044Z",
    transform: "translate(-1373.23 -866.48)",
    fill: "#f99b29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1328.69, 823.3)",
    filter: "url(#Trac\\xE9_170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_170-2",
    "data-name": "Trac\\xE9 170",
    d: "M1537.678,1028.669v1.969h-2.048v-1.969Z",
    transform: "translate(-1512.98 -1010.26)",
    fill: "#f99b29"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr-icon.10e9d1aaf2c7cbe6b115ca9b6d9f676d.svg";
export { ForwardRef as ReactComponent };